rs.module("jobs/memberstatementbatches/distribute",

    [
        "controls/data/grid",
        "common/select-helper"
    ],

    function (gridModule, selectHelper) {

        //
        // Initialize the module
        //
        function initialize(jsSelectors, ajaxUrl) {

            var distributeForm = $.js(jsSelectors.distributeForm);
            var methodSelect = distributeForm.js(jsSelectors.methodSelect);
            var methodSelectHelper = selectHelper.getHelper(methodSelect);
            var batchName = distributeForm.js(jsSelectors.batchName);
            var lastNameFromSelect = distributeForm.js(jsSelectors.lastNameFromSelect);
            var lastNameFromSelectHelper = selectHelper.getHelper(lastNameFromSelect);
            var lastNameToSelect = distributeForm.js(jsSelectors.lastNameToSelect);
            var lastNameToSelectHelper = selectHelper.getHelper(lastNameToSelect);
            var sortBySelect = distributeForm.js(jsSelectors.sortBySelect);
            var sortBySelectHelper = selectHelper.getHelper(sortBySelect);
            var printerSelect = distributeForm.js(jsSelectors.printerSelect);
            var printerSelectHelper = selectHelper.getHelper(printerSelect);

            // Hook up select event on the selectorto reload the grid data via ajax
            methodSelect.on('change', function () {
                var exported = "Export";
                var review = "Review";
                var distribute = "Distribute";
                if (methodSelect.val() == exported) {
                    batchName.val("");
                    lastNameFromSelectHelper.setValue("");
                    lastNameToSelectHelper.setValue("");
                    sortBySelectHelper.setValue("");
                    printerSelectHelper.setValue("");
                } else {
                    lastNameFromSelectHelper.setValue("A");
                    lastNameToSelectHelper.setValue("Z");
                    sortBySelectHelper.setValue("LastName,FirstName");

                    if (methodSelect.val() == review) {
                        printerSelectHelper.setValue("");
                    } else if (methodSelect.val() == distribute) {
                        $.getJSON(ajaxUrl, {})
                            .done(function (results) {
                                if (results.printerId) {
                                    printerSelectHelper.setValue(results.printerId);
                                } else {
                                    printerSelectHelper.setValue(printerSelect[0][0].value);
                                }
                            });
                    }
                }

                batchName.prop("disabled", methodSelect.val() == exported)
                lastNameFromSelectHelper.setDisabled(methodSelect.val() == exported);
                lastNameToSelectHelper.setDisabled(methodSelect.val() == exported);
                sortBySelectHelper.setDisabled(methodSelect.val() == exported);
                printerSelectHelper.setDisabled(methodSelect.val() == exported || methodSelect.val() == review);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);